<template lang="html">
  <Container dark name="moblie">
    <div class="client-container">
      <h1>AXIOX мобильный</h1>
      <div class="image-container">
          <div class="img-row">
            <div class="column">
              <img src="../assets/img/Axiox2.png">
            </div>
            <div class="column phone">
              <img src="../assets/img/Phone.png">
            </div>
            <div class="column">
              <img src="../assets/img/House.svg">
            </div>
          </div>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from '../components/Container.vue'

export default {
  components: { Container }
}
</script>

<style lang="css" scoped>

  @media screen and (max-width: 800px) {
    h1 {
      margin: auto;
      text-align: center;
      margin: 60px 0;
      font-size: 2.2rem;
    }
    .client-container {
      height: auto;
    }
    .img-row {
      width: 1200px;
      padding: 0 10px;
    }
  }

  @media screen and (min-width: 800px) {
    h1 {
      width: 88%;
      margin-left: 10%;
      margin-bottom: 55px;
      max-width: 20rem;
      font-size: 60px;
    }
    .img-row {
      width: 90%;
      max-width: 1700px;
    }
  }

  @media screen and (min-width: 1290px) {
    .img-row {
      /* padding: 0 5%; */
    }
  }

  .client-container {
    margin: 0;
    /* padding-top: 80px; */
    padding: 7% 0;
  }
  .image-container {
    background: url('../assets/img/background.svg') 50% 65% repeat-x;
    /* background-size: cover; */
    padding: 2vh 0;
    /* z-index:  */
    overflow-x: auto;
    /* min-width: 768px;
    width: 100vw; */
  }
  .column:last-child, .column:first-child {
    /* width: 32%; */
    margin: 0;
    margin-top: 30px;
    width: 30%;
    /* min-width: 200px; */
  }
  .column:last-child {
    float: right;
  }
  .column:first-child {
    float: left;
  }
  .phone {
    /* margin: auto; */
    /* margin: 0 7.5%; */
    width: 15%;
    /* min-width: 95px; */
  }
  .column {
    display: inline-block;
    /* float: left; */
    /* z-index: -1; */
    position: relative;
    /* width: 256px; */
    /* border: 1px solid red; */
  }
  .img-row {
    /* display: inline-block; */
    text-align: center;
    margin: auto;
    /* width: 90%; */
    /* min-width: 1250px; */
    /* max-width: 1700px; */
    /* width: 100%; */
    /* max-width: 1300px; */
    /* margin-top: 3%; */
    /* min-width: 568px; */
    /* border: 1px solid green; */
    z-index: 0 !important;
  }
  .column:last-child img, .column:first-child img {
    /* max-width: 400px; */
    /* width: 90%; */
    /* min-width: 200px; */
  }
  .column img {
    /* width: 200px; */
    width: 100%;
    /* height: 100%; */
  }
  h1 {
    font-weight: 200;
    line-height: 100%;
  }
</style>
